import Vue from 'vue'
import LDialog from '@/components/l-dialog'

let instance = null
const LDialogConstructor = Vue.extend(LDialog)

Vue.mixin({
  beforeCreate () {
    if (!this.$lPrompt) {
      this.$lPrompt = lPrompt
    }
  }
})
/**
 * @description 弹窗提示
 * @param {any} Boolean 关闭弹窗 ｜ Object 弹窗提示参数
 * @returns
 */
function lPrompt (options) {
  if (options === true && instance) {
    instance.$el.remove()
    instance.$destroy()
    instance = null
    return
  }

  let {
    title = '',
    message = '',
    cancelTxt = '取消',
    successTxt = '确定',
    successFn = null,
    cancelFn = null,
    showCancel = false,
  } = options

  if (!message) {
    return
  }
  // 单例
  if (!instance) {
    instance = new LDialogConstructor({
      el: document.createElement('div'),
    })
  }

  // 初始化值
  instance.visible = true
  instance.showCancel = cancelFn instanceof Function ? true : showCancel
  instance.$slots.title = instance.$createElement('div', null, title)
  instance.$slots.msg = typeof message === 'string' ? instance.$createElement('div', null, message) : message
  instance.cancleBtnText = cancelTxt
  instance.confirmBtnText = successTxt
  instance.hasCancleBtn = cancelFn instanceof Function


  // 确定事件
  instance.$on('confirm', function () {
    successFn instanceof Function ? successFn() : ''
    instance.$el.remove()
    instance.$destroy()
    instance = null
  })

  // 取消事件
  instance.$on('cancle', function () {
    cancelFn instanceof Function ? cancelFn() : ''
    instance.$el.remove()
    instance.$destroy()
    instance = null
  })

  document.body.appendChild(instance.$el)
}

export default lPrompt
